
import Microphone from "../../../assets/filled/Microphone.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MicrophoneIcon({ className, dataTestid = "MicrophoneIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Microphone data-testid={dataTestid} className={classes} {...rest} />
  );
}
